<template>
  <div ref="container">
    <a-modal :title="title" :width="1200" :visible="visible" :confirmLoading="confirmLoading" :getContainer="() => $refs.container" :maskStyle="{'top':'93px','left':'154px'}" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:15%;height: 80%;">
      <template slot="footer">
        <a-button key="back" v-if="isReadOnly" @click="handleCancel">
          关闭
        </a-button>
      </template>
      <a-spin :spinning="confirmLoading">
        <div class="box">
          <div class="item">
            <span>产品名称：</span>
            <span>{{formState.materialName}}</span>
          </div>
          <div class="item">
            <span>稽查二维码：</span>
            <span>{{formState.code}}</span>
          </div>
          <div class="item">
            <span>稽查人员：</span>
            <span>{{formState.createByName}}</span>
          </div>
          <div class="item">
            <span>稽查时间：</span>
            <span>{{formState.createTime}}</span>
          </div>
          <div class="item">
            <span>稽查结果：</span>
            <span v-if="formState.resultCode==1">正常</span>
            <span v-if="formState.resultCode==0">异常</span>
          </div>
          <div class="item">
            <span>备注:</span>
            <span>{{formState.remark}}</span>
          </div>
          <div class="item">
            <span>稽查位置：</span>
            <span>{{formState.address}}</span>
          </div>
          <div class="item">
            <span>经销商名称：</span>
            <span>{{formState.supplier}}</span>
          </div>
          <div class="item">
            <span>出库单号：</span>
            <span>{{formState.number}}</span>
          </div>
          <div class="item">
            <span>出库人员：</span>
            <span>{{formState.outorName}}</span>
          </div>
          <div class="item">
            <span>出库时间：</span>
            <span>{{formState.outTime}}</span>
          </div>
        </div>

      </a-spin>
    </a-modal>
  </div>
</template>
<script>
// import pick from 'lodash.pick'
// import { updateSecurityConfig } from '@/api/api'
import { mixinDevice } from '@/utils/mixin'
export default {
  name: 'AccountModal',
  mixins: [mixinDevice],
  data() {
    return {
      title: '稽查记录',
      visible: false,
      model: {},
      formState: {},
      isReadOnly: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      // validatorRules: {
      //   name: {
      //     rules: [{ required: true, message: '请输入防伪参数!' }],
      //   },
      // },
    }
  },
  created() {},
  methods: {
    add(record) {
      console.log(record, 'record')
      this.visible = true
      if (record) {
        this.formState = record
      }
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      this.close()
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>
<style scoped>
.box {
  font-size: 16px;
  display: flex;
  flex-direction: column;
}
.item {
  margin-left: 50px;
  margin-top: 30px;
}
</style>